import VueGtag from 'vue-gtag'
import { gtagId } from '@/core/composables/useSessionData'

export function install(app) {
  if (gtagId) {
    app.use(VueGtag, {
      config: { id: gtagId },
      params: {
        send_page_view: false,
        cookie_flags: 'SameSite=None;Secure',
      },
    })
  }
}
